import accordion from '@/templates/02-components/accordion/analytics.accordion';
import authorCard from '@/templates/02-components/author-card/analytics.author-card';
import banner from '@/templates/02-components/header/analytics.banner';
import bannerNotification from '@/templates/02-components/banner-notification/analytics.banner-notification';
import breadcrumb from '@/templates/02-components/breadcrumb/analytics.breadcrumb';
import cardListing from '@/templates/02-components/card-listing/analytics.card-listing';
import categoryListing from '@/templates/02-components/category-listing/analytics.category-listing';
import contactCard from '@/templates/02-components/contact-card/analytics.contact-card';
import contentRecsListing from '@/templates/02-components/content-recs-listing/analytics.content-recs-listing';
import distributorSearch from '@/templates/02-components/distributor-search/analytics.distributor-search';
import documentDownload from '@/templates/02-components/document-download/analytics.document-download';
import documentLibrary from '@/templates/02-components/document-library/analytics.document-library';
import featureBlock from '@/templates/02-components/feature-block/analytics.feature-block';
import footer from '@/templates/02-components/footer/analytics.footer';
import fullWidthText from '@/templates/02-components/full-width-text/analytics.full-width-text';
import header from '@/templates/02-components/header/analytics.header';
import iconBlock from '@/templates/02-components/icon-block/analytics.icon-block';
import mainNav from '@/templates/02-components/subcomponents/header/_nav/analytics.nav.js';
import newsArticleCard from '@/templates/02-components/subcomponents/_news-article-card/analytics.news-article-card.js';
import newsFilter from '@/templates/02-components/news-filter/analytics.news-filter';
import pagination from '@/templates/02-components/pagination/analytics.pagination';
import powerTrack from '@/templates/02-components/power-track/analytics.power-track';
import reciteMe from '@/templates/02-components/recite-me/analytics.recite-me';
import rte from '@/templates/02-components/rich-text-content/analytics.rte';
import searchResults from '@/templates/02-components/search-results/analytics.search-results';
import searchResultsFilter from '@/templates/02-components/search-results-filter/analytics.search-results-filter';
import socialShare from '@/templates/02-components/social-share/analytics.social-share';
import supplierSearch from '@/templates/02-components/supplier-search/analytics.supplier-search';
import triages from '@/templates/02-components/_triage/analytics.triage';
import epiFormConnections from '@/templates/02-components/epi-forms-connections/analytics.epi-forms-connections';

function init() {
  accordion();
  authorCard();
  banner();
  bannerNotification();
  breadcrumb();
  cardListing();
  categoryListing();
  contactCard();
  contentRecsListing();
  distributorSearch();
  documentDownload();
  documentLibrary();
  featureBlock();
  footer();
  fullWidthText();
  header();
  iconBlock();
  mainNav();
  newsArticleCard();
  newsFilter();
  pagination();
  powerTrack();
  reciteMe();
  rte();
  searchResults();
  searchResultsFilter();
  socialShare();
  supplierSearch();
  triages();
  epiFormConnections();
}

export default init;
